import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect, useMemo } from 'react';
import { styled } from 'styled-components';
import '../ScrollGroup/index.mjs';
import { useStickyGrid } from './context.mjs';
import { useScrollGroupItem } from '../ScrollGroup/useScrollGroupItem.mjs';
"use strict";
function StickyGridHeader({
  children,
  nonScrollChildren,
  stickOffset,
  onStickyStateChange
}) {
  const grid = useStickyGrid();
  const {
    templateColumns,
    gap
  } = grid;
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  useScrollGroupItem({
    refObject: contentRef
  });
  const [elementHeight, setElementHeight] = useState(null);
  const [isStuck, setIsStuck] = useState(false);
  useEffect(() => {
    onStickyStateChange?.(isStuck);
  }, [isStuck, onStickyStateChange]);
  useEffect(() => {
    const element = wrapperRef.current;
    if (!element) return;
    const updateHeight = () => setElementHeight(element.offsetHeight);
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(element);
    updateHeight();
    return () => {
      resizeObserver.disconnect();
    };
  }, [wrapperRef]);
  const THRESHOLD = useMemo(() => {
    if (!elementHeight || !stickOffset) return 1;
    const value = (elementHeight - stickOffset) / elementHeight;
    const INTERSECTION_RATIO_BUFFER = 1.00001;
    return Math.max(0, Math.min(1, value * INTERSECTION_RATIO_BUFFER));
  }, [elementHeight, stickOffset]);
  useEffect(() => {
    if (!wrapperRef.current) {
      setIsStuck(false);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;
      setIsStuck(entry.intersectionRatio < THRESHOLD);
    }, {
      threshold: THRESHOLD
    });
    observer.observe(wrapperRef.current);
    return () => {
      observer.disconnect();
    };
  }, [THRESHOLD]);
  return /* @__PURE__ */jsxs(HeaderWrap, {
    ref: wrapperRef,
    $stickOffset: stickOffset,
    children: [/* @__PURE__ */jsx(StyledStickyHeader, {
      ref: contentRef,
      $templateColumns: templateColumns,
      $gap: gap,
      children
    }), nonScrollChildren?.({
      grid,
      isStuck
    })]
  });
}
const HeaderWrap = styled.div`
  width: 100%;
  position: sticky;
  top: -${({
  $stickOffset
}) => $stickOffset ?? 0}px;
  z-index: 2;
  transition: box-shadow 0.25s;
`;
const StyledStickyHeader = styled.div`
  display: grid;

  gap: ${({
  $gap
}) => $gap ?? 0};
  grid-template-columns: ${({
  $templateColumns
}) => $templateColumns};
  width: 100%;
  position: sticky;
  z-index: 2;

  transition: box-shadow 0.25s;

  overflow: auto;
  overscroll-behavior-x: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export { StickyGridHeader };
//# sourceMappingURL=StickyGridHeader.mjs.map
